import React from "react";
import ReactDOM from "react-dom/client";
import "./reset.css";
import "./index.css";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import { CanvasProvider } from "./utils/DrawdleContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CanvasProvider>
        <App />
      </CanvasProvider>
    </BrowserRouter>
  </React.StrictMode>
);
